export enum Height {
    NavigationHeader = "60px",
    BottomModalHeader = "50px",
    BottomPadding = "150px"
}
